import { render, staticRenderFns } from "./courseContent.vue?vue&type=template&id=6a5beaba&scoped=true&"
import script from "./courseContent.vue?vue&type=script&lang=js&"
export * from "./courseContent.vue?vue&type=script&lang=js&"
import style0 from "./courseContent.vue?vue&type=style&index=0&id=6a5beaba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5beaba",
  null
  
)

export default component.exports